var React = require('react');

function SketchLogoInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M64.386 17.638L52.54 2.56a1.082 1.082 0 0 0-.728-.405L32.428.001c-.027-.003-.054.001-.081 0a.933.933 0 0 0-.079 0c-.026.001-.053-.003-.08 0L12.803 2.155a1.082 1.082 0 0 0-.728.405L.23 17.638a1.08 1.08 0 0 0 .028 1.366l31.23 36.618a1.08 1.08 0 0 0 1.641 0l31.23-36.618a1.08 1.08 0 0 0 .028-1.366zm-12.873-1.797L35.716 2.54 50.68 4.202l.832 11.64zm-.58 3.544l-18.625 33.33-18.626-33.33h37.251zM14.797 17.23l17.51-14.746 17.511 14.746H14.797zm-1.694-1.39l.831-11.64L28.9 2.54 13.103 15.84zm-2.26 1.39h-7.55l8.305-10.57-.755 10.57zm.371 2.154l14.825 26.529-22.627-26.53h7.802zm42.187 0h7.802L38.576 45.914l14.825-26.53zm.372-2.154l-.755-10.57 8.304 10.57h-7.55z","fillRule":"nonzero"}));
}

SketchLogoInline.defaultProps = {"width":"65","height":"56","viewBox":"0 0 65 56"};

module.exports = SketchLogoInline;

SketchLogoInline.default = SketchLogoInline;
